import { AgentioMethod } from './types';

import type { ScriptFunctionReturn } from '../../types';

// TODO: If your script needs an ID or key, add it as a parameter to this function and inject it into the script
export function getAgentioScript(agentioPixelId: string): ScriptFunctionReturn {
  const sdkLoader = `
  !function(w, d) {
    var id = 'agentio-pixel'
    if (!d.getElementById(id)) {
      var agentioScript = d.createElement("script");
       agentioScript.src = "https://static.agentio.com/agentio-pixel.js";
      agentioScript.async = true;
      agentioScript.id = id;
      var s = d.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(agentioScript, s);

      agentioScript.onload = () => {
        var pixelId = "${agentioPixelId}";
        if (!w.${AgentioMethod.Init}) {
          return;
        }
        w.${AgentioMethod.Init}(pixelId);
      };
      d.head.appendChild(agentioScript);
    }
  }(window, document);
  `;

  return { sdkLoader };
}
